import CableController from './cable_controller';

export default class extends CableController {
  static targets = [
    'message',
  ];

  received() { // eslint-disable-line class-methods-use-this
    window.location.reload();
  }

  get channel() {
    return super.channel || 'PropertiesChannel';
  }
}
